import { useCreateAuthorityMutation } from '@/graphql/types';

export default function (authority: { name: string; cvr: string }) {
  const mutation = useCreateAuthorityMutation({});

  function call() {
    return mutation.mutate({
      input: {
        name: authority.name,
        cvr: authority.cvr
      }
    });
  }

  return {
    ...mutation,
    call
  };
}
